import React, { lazy } from 'react';

const GLQNEExportListing = lazy(() =>
  import('./GLQNEExportListing').then(module => ({
    default: module.GLQNEExportListing,
  })),
);

const GLQNEExportForm = lazy(() =>
  import('./GLQNEExportForm').then(module => ({
    default: module.GLQNEExportForm,
  })),
);

const glQNEExportRoutes = [
  {
    props: { exact: true, path: '/gl-interface/data-export' },
    component: <GLQNEExportListing />,
  },
  {
    props: { exact: true, path: '/gl-interface/data-export/add' },
    component: <GLQNEExportForm mode="add" />,
  },
  {
    props: { exact: true, path: '/gl-interface/data-export/:exportID/export' },
    component: <GLQNEExportForm mode="export" />,
  },
  {
    props: { exact: true, path: '/gl-interface/data-export/:exportID/view' },
    component: <GLQNEExportForm mode="view" />,
  },
];

export default glQNEExportRoutes;
